<template>
  <div class="search-box">
    <!-- input 框 -->

    <div class="search-input-box" :class="{ activeShowA: !showASearch }">
      <div class="search-input">
        <el-input
          placeholder="请输入内容"
          v-model="searchInput"
          clearable
          @clear="clearHandler"
          @input="wordLimit($event, 'searchInput', '', maxlength)"
          :maxlength="maxlength"
          ref="searchInput"
        >
          <el-button slot="append" class="search-btn" @click="searchClick"
            >搜索</el-button
          >
        </el-input>
      </div>

      <el-button
        v-if="showDetailSearch"
        type="info"
        class="btn-sr advanced-search"
        @click="advancedSearchHandler"
      >
        高级搜索
      </el-button>
      <el-button v-if="isLogin" class="myCollectBtn" @click="jumpToPage">
        我的收藏
      </el-button>
    </div>
    <!-- 
        <div 
            v-if="showDetailSearch"
            class="keywordBox"
            >
            <span 
                v-for="(item, key) in keywordList"
                :key="key"
                @click="handleSelectKeyword(item)"
                >
                {{ item }}
            </span>
        </div> -->

    <search-bar
      v-model="fileType"
      label="资讯类别"
      :afterClick="handleFileTypeChange"
      :data="fileTypes"
      :props="{
        label: 'dictName',
        value: 'dictCode',
      }"
    >
    </search-bar>

    <el-collapse-transition>
      <div v-if="showASearch">
        <!-- isNotShowAll showMore -->
        <div class="search-bar">
          <div class="label">来源：</div>
          <div class="list">
            <el-cascader
              class="mr20 fl"
              v-model="sourceArr"
              @change="handleChangeSource"
              :collapse-tags="true"
              placeholder="来源"
              :options="options"
              style="width: 350px"
              :props="{ multiple: true, label: 'dictName', value: 'dictCode' }"
              size="small"
            >
            </el-cascader>
          </div>
        </div>
        <div class="search-bar">
          <div class="label">发布时间：</div>
          <div class="list">
            <el-date-picker
              class="mr20 fl"
              v-model="publishTime"
              type="daterange"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="changeTime"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              unlink-panels
              size="small"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import SearchBar from "@components/sys/list-search-bar-item";
import sourceSelect from "./source-select.vue";
import { mapGetters } from "vuex";
import utils from "@mixins/utils";
export default {
  mixins: [utils],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    fileTypes: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Object],
      default: () => {},
    },
    label: {
      type: String,
      default: "",
    },
    props: {
      type: Object,
      default: () => ({
        label: "dicname",
        value: "diccode",
      }),
    },
    action: {
      type: String,
      default: "",
    },
    all: {
      type: Boolean,
      default: true,
    },
    afterClick: {
      type: Function,
      default: function () {},
    },
    fileTypeChange: {
      type: Function,
      default: function () {},
    },
    "2way": {
      type: String,
    },
    showDetailSearch: {
      type: Boolean,
      default: false,
    },
    defaultFileType: {
      type: String,
    },
    // 我的收藏链接地址
    collectionUrl: {
      type: String,
    },
    visitlocation: {
      type: String,
      default: "",
    },
  },
  components: {
    SearchBar,
    sourceSelect,
  },
  data() {
    return {
      innerData: [],

      searchInput: "",
      publishTime: "",
      showASearch: false,

      pickerOptions: {
        shortcuts: [
          {
            text: "时间不限",
            onClick(picker) {
              picker.$emit("pick", ["", ""]);
            },
          },
          {
            text: "一天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一周内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一月内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "一年内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      keywordList: ["招标", "投标", "采购"],
      fileType: "",
      isLogin: false,
      //来源
      sourceArr: [],
      options: [],
      maxlength: 50,
    };
  },
  watch: {
    data: {
      handler(n, o) {
        if (n) {
          this.dataHandle();
        }
      },
      deep: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    usingData() {
      if (this.action) {
        return this.innerData;
      } else {
        return this.data;
      }
    },
    ...mapGetters({
      nickname: "userinfo/getNickname",
    }),
  },
  methods: {
    // this.setCzc(['首页', '筛选' , '推荐内容选择城市', index ,'home-select-city'])
    //搜索
    searchClick() {
      this.model.title = this.searchInput;
      this.searchQuery();
    },
    clearHandler() {
      this.searchInput = "";
      this.model.title = this.searchInput;
    },
    searchQuery() {
      this.$emit("search");
    },

    // 选择关键词
    handleSelectKeyword(keyword) {
      this.model.title = keyword;
      this.searchInput = keyword;
      this.searchQuery();
    },

    advancedSearchHandler() {
      this.showASearch = !this.showASearch;
    },

    // 切换时间
    changeTime(val) {
      this.model.pageIndex = 1;
      if (val) {
        this.model.startTime = val[0];
        this.model.endTime = val[1];
      } else {
        this.model.startTime = "";
        this.model.endTime = "";
      }
      this.searchQuery();
    },

    handleFileTypeChange(val, index) {
      this.$emit("fileTypeChange", val, index);
    },
    //处理数据
    dataHandle() {
      // this.options=this.data.filter(e=>{
      //     return e.dictName != '各协会平台'
      // })
      this.options = this.data;
    },
    handleChangeSource(value) {
      var target = [];
      value.forEach((arr) => {
        if (arr && arr.length > 0) {
          target.push(arr[arr.length - 1].trim());
        }
      });
      this.model.sourceStrs = target.length ? target.join(",") : "";
      this.searchQuery();
    },
    // 跳转页面
    jumpToPage() {
      if (this.visitlocation) {
        this.$store.dispatch("analysis/updateHits", {
          visitlocation: this.visitlocation,
        });
      }

      this.$router.push({
        path: this.collectionUrl,
      });
    },
  },
  mounted() {
    this.dataHandle();
    this.isLogin = !!this.nickname;
    if (this.$route.query.title) {
      this.searchInput = this.$route.query.title;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.search-input-box {
  display: flex;
  height: 40px;
  align-items: center;
  margin-top: 20px;

  .search-input {
    width: 600px;

    ::v-deep .el-autocomplete {
      width: 100%;
    }

    ::v-deep .el-input__inner {
      border-radius: 0px;
      // background-color: #eff3ff;
      border: 1px solid $primaryColor;
    }

    ::v-deep .el-input-group__append {
      border-radius: 0px;
    }

    .search-btn {
      border-radius: 0px;
      background-color: $primaryColor;
      color: white;
      border: 1px solid $primaryColor;
    }
  }
  .btn-sr {
    border-radius: 0px;
    border: 1px solid $primaryColor;
    background-color: #e6edff;
    color: $primaryColor;
    margin-left: 16px;
  }
}
// .activeShowA {
//     margin: 20px 0;
// }

.search-bar {
  overflow: hidden;
  color: #333;
  line-height: 1em;
  padding: 20px 0;

  & + .search-bar {
    border-top: 1px dashed #f0f0f0;
  }

  .label {
    float: left;
    margin-right: -6em;
    font-weight: bold;
  }

  .list {
    overflow: hidden;
    margin: -8px 0;
    margin-left: 6em;
    float: left;

    .item {
      float: left;
      margin: 8px 24px 8px 0;
      cursor: pointer;

      &:hover {
        color: $primaryColor;
      }

      &.active {
        color: $primaryColor;
        font-weight: bold;
      }
    }
  }
}
.keywordBox {
  padding: 10px 0 0 60px;
  span {
    margin-right: 30px;
    cursor: pointer;
  }
}

.myCollectBtn {
  margin-left: 40px;
}
</style>
